import { CalendarCheck2 } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { CheckList, PhoneFrame } from '../compass/shared';

// Section 6 — the deterministic daily planner. Rule-based suggestions that
// cite their underlying data; genuine mobile screenshot.
export const ReachPlanner = ({ sp }) => (
  <section aria-labelledby="reach-planner-heading" data-testid="reach-planner" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2">
        <Reveal>
          <SectionHeader
            align="left"
            eyebrow="Daily Planner"
            title="Your day, deterministically"
            description={sp.plannerCopy}
            testid="reach-planner-header"
          />
          <div className="mt-8">
            <CheckList items={sp.plannerPoints || []} testid="reach-planner-points" />
          </div>
          <p className="mt-6 flex items-start gap-2.5 rounded-lg border border-emerald-100 bg-emerald-50/60 p-4 text-sm font-medium leading-relaxed text-navy-800">
            <CalendarCheck2 className="mt-0.5 h-4 w-4 shrink-0 text-service-growth" aria-hidden="true" />
            Rule-based recommendations across your book — every suggestion cites the data behind it, so the plan can always be explained.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="flex justify-center">
            <PhoneFrame shot={sp.shots.plannerMobile} className="w-44 sm:w-56" data-testid="reach-planner-visual" />
          </div>
          <p className="mt-4 text-center text-[11px] font-semibold uppercase tracking-widest text-slate-400">
            Product visuals show illustrative demonstration data
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
